import {AxiosError} from 'axios'

import {useSettingsQuery} from '@settings/modules/common/providers'

export const useJanusSpecificKpis = (
  upmPlantId: string,
  unitId: string,
  upmMappingType: number,
  upmId: string
) => {
  return useSettingsQuery('janusSpecificKpis', [{upmPlantId, upmId, upmMappingType, unitId}], {
    enabled: !!upmId,
    retry: (failureCount, error) => {
      const status = (error as AxiosError)?.response?.status
      if (status === 404) return false
      return failureCount < 2
    }
  })
}
